import Breadcrumb from "components/Common/Breadcrumb"
import React, { useEffect, useMemo, useState } from "react"
import { FaEdit, FaEye, FaPlus } from "react-icons/fa"
import { MdDelete } from "react-icons/md"
import { Button, Card, CardBody, Input, Table } from "reactstrap"
import Swal from "sweetalert2"
import RolesModal from "./RoleModal"
import { fetchData, FetchDeleteData } from "utils/Common_api_functions"
import Loader from "components/Loader/loader"
import moment from "moment/moment"
import { usePermissionData } from "AppContext"
import PermittedComponent from "PermittedComponent"

const RolesIndex = () => {
  const { checkAccess, getStaffInfo } = usePermissionData()

  document.title = "Roles | Siddhi Tax Consultant "

  // pagination + search
  const [pageSize, setPageSize] = useState(20)
  const [searchString, setSearchString] = useState("")

  const [loading, setLoading] = useState(false)
  // roles data
  const [rolesData, setRolesData] = useState([])

  useEffect(() => {
    getRoles()
  }, [])

  async function getRoles() {
    const APIdata = await fetchData(setLoading, "roles")
    if (APIdata?.success) {
      setRolesData(APIdata?.data?.reverse())
    }
  }

  // filtered data
  const filteredData = useMemo(() => {
    return rolesData.filter(item =>
      item.roleName.toLowerCase().includes(searchString.toLowerCase())
    )
  }, [rolesData, searchString])

  // Pagination
  const [currentPage, setCurrentPage] = useState(1)

  const totalPages = Math.ceil(filteredData.length / pageSize)
  const start = (currentPage - 1) * pageSize

  const paginatedData = useMemo(() => {
    const end = start + pageSize
    return filteredData.slice(start, end)
  }, [filteredData, currentPage, pageSize])

  // Add Edit Modal
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedroles, setSelectedroles] = useState({})
  const [viewModal, setViewModal] = useState(false)

  const handleDelete = id => {
    Swal.fire({
      title: `Are you sure you want to delete this Role?`,
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIdata = await FetchDeleteData(setLoading, "roles", id)
        if (APIdata?.data?.success) {
          Swal.fire({
            title: "Role Deleted Successfully.",
            text: APIdata?.data?.message,
            icon: "success",
          }).then(result => {
            if (result.isConfirmed) {
              window.location.reload()
            }
          })
        } else {
          Swal.fire({
            title: "Error Deleting role.",
            text: APIdata?.response?.data?.message,
            icon: "error",
          })
        }
      }
    })
  }

  return (
    <PermittedComponent isAccess={checkAccess(3, "view")}>
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb
        title="Settings"
        breadcrumbItem="Roles & Permissions"
      ></Breadcrumb>
      <Card>
        <CardBody>
          {/* Top controls */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex gap-3">
              <Input
                type="select"
                value={pageSize}
                onChange={e => setPageSize(Number(e.target.value))}
                className="rounded-4 w-auto pe-5"
              >
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </Input>

              <Input
                className="rounded-4"
                placeholder="Search Role"
                value={searchString}
                onChange={e => setSearchString(e.target.value)}
              />
            </div>
            {checkAccess(3, "add") && (
            <Button
              className="btn-blue rounded-4 px-3"
              onClick={() => {
                setSelectedroles({}), setViewModal(false), setModalOpen(true)
              }}
            >
              <FaPlus className="me-2" />
              Add Role
            </Button>
            )}
          </div>

          {/* Table */}
          <Table bordered responsive>
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Role Name</th>
                <th>Created At</th>
                {/* <th>Updated At</th> */}
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    No Role found
                  </td>
                </tr>
              ) : (
                paginatedData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item?.roleName}</td>
                    <td>{moment(item.createdAt).format("DD-MM-YYYY")}</td>
                    {/* <td>{moment(item.updatedAt).format("DD-MM-YYYY")}</td> */}
                    <td>
                      {checkAccess(3, "view") && (
                      <Button
                        className="bg-transparent text-dark me-3"
                        onClick={() => {
                          setSelectedroles(item),
                            setViewModal(true),
                            setModalOpen(true)
                        }}
                      >
                        <FaEye size={16} />
                      </Button>
                      )}
                      {checkAccess(3, "edit") && (
                      <Button
                        className="bg-transparent text-dark me-3"
                        onClick={() => {
                          setSelectedroles(item),
                            setViewModal(false),
                            setModalOpen(true)
                        }}
                      >
                        <FaEdit size={16} />
                      </Button>
                      )}
                      {checkAccess(3, "delete") && (
                      <Button
                        className="bg-transparent text-dark "
                        onClick={() => handleDelete(item?.id)}
                      >
                        <MdDelete size={18} />
                      </Button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
          <nav
            aria-label="Page navigation example"
            className="d-flex justify-content-between mt-3"
          >
            <h5>
              Showing {start + 1} to{" "}
              {Math.min(start + pageSize, filteredData.length)} of{" "}
              {rolesData.length} entries
            </h5>
            <ul className="pagination mb-0">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                >
                  Previous
                </button>
              </li>

              {[...Array(totalPages)].map((_, i) => {
                const pageNum = i + 1
                return (
                  <li
                    key={pageNum}
                    className={`page-item ${
                      pageNum === currentPage ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(pageNum)}
                    >
                      {pageNum}
                    </button>
                  </li>
                )
              })}

              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() =>
                    setCurrentPage(prev => Math.min(prev + 1, totalPages))
                  }
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </CardBody>
      </Card>

      <RolesModal
        open={modalOpen}
        toggle={() => setModalOpen(false)}
        selectedRole={selectedroles}
        setselectedRole={setSelectedroles}
        viewOnly={viewModal}
        getRoles={getRoles}
      ></RolesModal>
    </div>
    </PermittedComponent>
  )
}

export default RolesIndex
